module.exports = __webpack_public_path__ + "static/media/CHARGING_TERMINAL-21.3a7735fe.png";